<template>
  <div>
    <v-file-input
      v-if="!disabled || !toEdit || !toEdit.filename"
      v-bind="field"
      v-model="uploadedFile"
      :label="fileSelectorLabel"
      :rules="rules"
      :disabled="disabled"
      :accept="type"
      :prepend-icon="type === 'image/*' ? 'mdi-file-image-outline' : 'mdi-file-document'"
      :clearable="false"
      @change="fileChange"
      small-chips
      truncate-length="64"
    />
    <v-expand-transition>
      <v-text-field
        v-if="!readOnly && toEdit && toEdit.url"
        v-model="toEdit.filename"
        :rules="rules"
        :label="label"
        :disabled="disabled"
      />
    </v-expand-transition>
    <v-scale-transition>
      <div class="image-wrapper">
        <figure v-if="type.startsWith('image/') && toEdit && toEdit.url">
          <img v-auth-image="toEdit.url">
        </figure>
      </div>
    </v-scale-transition>
  </div>
</template>

<script>
import { getBase64, removeFileExtension } from '@bit/streamline.web.utils'

export default {
  name: 'FileField',
  props: {
    field: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    // eslint-disable-next-line vue/require-prop-types
    toEdit: {
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: () => 'image/*'
    }
  },
  data () {
    return {
      uploadedFile: null
    }
  },
  computed: {
    // Append the asterix also to the end of the file selector label if the filename is required
    fileSelectorLabel () {
      const fileLabel = 'Selecteer nieuw bestand'
      return this.label.endsWith('*') ? `${fileLabel}*` : fileLabel
    }
  },
  watch: {
    toEdit (toEdit) {
      if (!toEdit || toEdit.data === null || toEdit.fingerprint) {
        this.uploadedFile = null
      }
    }

  },
  methods: {
    async fileChange (newFile) {
      const base64 = await getBase64(newFile)

      this.$emit('update:toEdit', {
        filename: removeFileExtension(newFile.name),
        file: base64.split(',')[1],
        url: URL.createObjectURL(newFile)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .image-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    figure {
      width: 45%;
      max-width: 320px;

      img {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);

      }
    }
  }
</style>
